<div *ngIf="!justinoActive" class="consentimiento-container">
  <div class="consentimiento-card">
    <h1 class="consentimiento-title">Consentimiento Informado para el Uso del Asistente Inteligente Justino</h1>
    
    <div class="consentimiento-content">
      <p class="consentimiento-intro">
        Antes de utilizar el asistente inteligente Justino, es importante que lea, comprenda y acepte los siguientes términos y condiciones de uso.
      </p>
      
      <div class="consentimiento-text">
        <h3>1. Naturaleza del servicio</h3>
        <p>
          Justino es un asistente inteligente diseñado para proporcionar información y asistencia en diversas tareas. Sin embargo, las respuestas generadas pueden contener imprecisiones, errores o interpretaciones incorrectas. No se garantiza la exactitud, veracidad ni actualidad de la información proporcionada.
        </p>
        
        <h3>2. Responsabilidad del usuario</h3>
        <p>
          Usted es responsable de verificar toda la información generada por Justino, especialmente en asuntos críticos, legales, médicos, financieros, técnicos o que requieran asesoramiento profesional.
        </p>
        <p>
          Justino no debe utilizarse como única fuente para tomar decisiones importantes. Se recomienda acudir a profesionales calificados cuando corresponda.
        </p>
        
        <h3>3. Uso de datos y entrenamiento del sistema</h3>
        <p>
          Al utilizar este servicio, usted acepta que sus interacciones pueden ser utilizadas para:
        </p>
        <ul class="consentimiento-list">
          <li>Entrenamiento y mejora del modelo</li>
          <li>Análisis de patrones de uso</li>
          <li>Optimización del rendimiento y funcionamiento del sistema</li>
        </ul>
        <p>
          Los datos podrán ser anonimizados o seudonimizados para proteger su identidad, según corresponda.
        </p>
        
        <h3>4. Datos recopilados</h3>
        <p>
          Podemos recopilar:
        </p>
        <ul class="consentimiento-list">
          <li>El contenido de sus conversaciones</li>
          <li>Metadatos técnicos (fecha, hora, dispositivo, etc.)</li>
          <li>Información personal que usted proporcione voluntariamente</li>
        </ul>
        
        <h3>5. Finalidad del tratamiento de datos</h3>
        <p>
          Sus datos se utilizarán únicamente para:
        </p>
        <ul class="consentimiento-list">
          <li>Mejorar la calidad del servicio</li>
          <li>Desarrollar nuevas funciones</li>
          <li>Fines estadísticos y de seguridad</li>
        </ul>
        
        <h3>6. Compartición y almacenamiento de datos</h3>
        <p>
          La información podrá almacenarse en servidores propios o de terceros autorizados. Cualquier uso o compartición se realizará conforme a la política de privacidad vigente.
        </p>
        
        <h3>7. Derechos del usuario</h3>
        <p>
          Usted puede solicitar en cualquier momento:
        </p>
        <ul class="consentimiento-list">
          <li>Acceso a sus datos</li>
          <li>Rectificación o eliminación de los mismos</li>
          <li>Retiro del consentimiento</li>
          <li>Información sobre cómo se utilizan sus datos</li>
        </ul>
        <p>
          Los procedimientos específicos se detallan en la política de privacidad.
        </p>
        
        <h3>8. Seguridad de la información</h3>
        <p>
          Se aplican medidas técnicas y organizativas razonables para proteger los datos frente al acceso no autorizado, pérdida o uso indebido.
        </p>
        
        <h3>9. Limitación de responsabilidad</h3>
        <p>
          El uso de Justino se realiza bajo su propia responsabilidad. No asumimos responsabilidad por decisiones tomadas en base a la información generada por el asistente.
        </p>
      </div>
    </div>
    
    <div class="consentimiento-actions">
      <button 
        type="button" 
        class="btn-govco bg-danger text-white" 
        (click)="onDeclinar()">
        Declinar
      </button>
      <button 
        type="button" 
        class="btn-govco fill-btn-govco" 
        (click)="onAceptar()">
        Aceptar
      </button>
    </div>
  </div>
</div>
<div *ngIf="justinoActive" class="consentimiento-container">
  <div class="consentimiento-card">
    <h1 class="consentimiento-title">Consentimiento Informado</h1>
    <div class="consentimiento-content">
      <p class="consentimiento-intro text-center">
        Usted ya ha aceptado el consentimiento informado.
      </p>
    </div>
  </div>
</div>
